import React from "react";

// Modal (same shell as the flight-details one) showing what the included transfer actually is:
// each leg of the journey in order — vehicle, class, and where it runs from and to. This is what
// makes "Multi-Leg Transfer" concrete: Taxi to the harbour, ferry crossing, taxi to the resort.
export default function PackageSearchResultTransferDetails({ result, onClose }) {
    const legs = result.transferLegs ?? [];

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="transition flex items-center justify-center min-h-screen pt-14 px-4 pb-20 text-center sm:block sm:p-0">
                <div
                    className="fixed inset-0 bg-gray-500/75 bg-opacity-75"
                    onClick={() => onClose()}
                ></div>

                <div className="inline-block transform translate-0 transition-all align-bottom bg-white rounded-2xl pt-6 text-left overflow-hidden shadow-xl sm:my-8 sm:align-middle sm:max-w-[31.25rem] sm:w-full">
                    <div className="absolute top-2 right-2">
                        <button
                            onClick={() => onClose()}
                            className="text-gray-400 hover:text-content_3"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className="px-6 pb-6">
                        <h3 className="text-lg font-semibold text-primary mb-1">
                            {result.includedTransferLabel || "Transfer details"}
                        </h3>
                        <p className="text-xs text-content_3 mb-4">
                            Included in the price shown, each way
                        </p>

                        <ol className="relative">
                            {legs.map((leg, i) => (
                                <li key={i} className="flex gap-3 pb-5 last:pb-0">
                                    {/* Step marker + connecting line, so the legs read as one journey */}
                                    <div className="flex flex-col items-center">
                                        <div className="w-6 h-6 shrink-0 rounded-full bg-indigo-600 text-white text-xs font-semibold flex items-center justify-center">
                                            {i + 1}
                                        </div>
                                        {i < legs.length - 1 && (
                                            <div className="flex-1 w-px bg-gray-300 mt-1"></div>
                                        )}
                                    </div>
                                    <div className="min-w-0">
                                        <div className="flex items-center gap-2 flex-wrap">
                                            <span className="text-sm font-medium text-primary">
                                                {leg.vehicle}
                                            </span>
                                            {leg.vehicleClass && (
                                                <span className="text-[0.625rem] uppercase tracking-wide font-semibold text-content_3 bg-tertiary rounded-full px-2 py-0.5">
                                                    {leg.vehicleClass}
                                                </span>
                                            )}
                                        </div>
                                        {(leg.from || leg.to) && (
                                            <div className="text-xs text-content_2 mt-0.5">
                                                {leg.from} &rarr; {leg.to}
                                            </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>

                    <div className="bg-tertiary rounded-lg px-3 py-2 text-center">
                        <p className="text-xs text-gray-500">
                            The return journey follows the same route in reverse
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
